import { useEffect, useState } from "react";
import { getTmsProductionMetadata } from "../../../Services/productionMetadata";

const normalize = (items = []) =>
  items.map((item) => ({
    id: item?.id ?? item?.Id ?? null,
    text: item?.text ?? item?.Text ?? item?.name ?? item?.Name ?? ""
  }));

export function useTmsMetadata(selectedVerticalIds = [], clientId = null) {
  const [documentTypes, setDocumentTypes] = useState([]);
  const [verticals, setVerticals] = useState([]);
  const [productLines, setProductLines] = useState([]);
  const [disciplines, setDisciplines] = useState([]);
  const [disciplinesLoading, setDisciplinesLoading] = useState(false);
  const [disciplinesError, setDisciplinesError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const loadMetadata = async () => {
      setLoading(true);
      setProductLines([]);

      try {
        const data = await getTmsProductionMetadata({ clientId });
        if (!isMounted) {
          return;
        }

        setDocumentTypes(normalize(data?.documentTypes || []));
        setVerticals(normalize(data?.verticals || []));
        setProductLines(normalize(data?.productLines || []));
        setError(null);
      } catch (err) {
        if (isMounted) {
          setError({ general: err });
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    };

    loadMetadata();

    return () => {
      isMounted = false;
    };
  }, [clientId]);

  useEffect(() => {
    let isMounted = true;

    if (!selectedVerticalIds.length) {
      setDisciplines([]);
      setDisciplinesError(null);
      setDisciplinesLoading(false);
      return () => {
        isMounted = false;
      };
    }

    setDisciplinesLoading(true);

    (async () => {
      try {
        const data = await getTmsProductionMetadata({
          clientId,
          verticalIds: selectedVerticalIds
        });

        if (!isMounted) {
          return;
        }

        setDisciplines(normalize(data?.disciplines || []));
        setDisciplinesError(null);
      } catch (err) {
        if (isMounted) {
          setDisciplines([]);
          setDisciplinesError(err);
        }
      } finally {
        if (isMounted) {
          setDisciplinesLoading(false);
        }
      }
    })();

    return () => {
      isMounted = false;
    };
  }, [selectedVerticalIds, clientId]);

  return {
    documentTypes,
    verticals,
    productLines,
    disciplines,
    loading,
    error,
    disciplinesLoading,
    disciplinesError
  };
}
